import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { ComponentTheme } from '@helpers/themeEnum';
import { headingStyles, paragraphLarge } from '@helpers/typography';
import { FakeButton } from '@stories/Components/Buttons/GeneralButton/Button';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.SiteWide} {
    @media ${from(Device.Tablet)} {
      ${baseGrid};
    }
  }
`;
const ContentArea = styled.div `
  grid-column: span 4;

  @media ${until(Device.Tablet)} {
    padding-bottom: 16px;
  }
`;
const Title = styled.h2 `
  ${headingStyles};
  font-size: ${fluid(35, 60)};
  line-height: ${fluid(45, 70)};
`;
const Content = styled.p `
  ${paragraphLarge};
`;
const LogoGrid = styled.div `
  ${baseGrid};
  grid-column: 6 / span 7;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${fluid(8, 36)};
  padding: ${fluid(24, 75)};
  border-radius: ${fluid(25, 50)};
  --bgColour: ${brand.orange.light};
  background-color: var(--bgColour);

  &[data-theme=${ComponentTheme.Blue}] {
    --bgColour: ${brand.blue.light};
  }

  &[data-theme=${ComponentTheme.Green}] {
    --bgColour: ${brand.green.light};
  }

  &[data-theme=${ComponentTheme.Yellow}] {
    --bgColour: ${brand.yellow.light};
  }

  @media ${from(Device.DesktopSmall)} {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const Partner = styled.a `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: ${fluid(19, 26)} ${fluid(16, 26)};
  background-color: ${brand.white};
  border-radius: ${fluid(10, 25)};
  aspect-ratio: 129/95;
  height: 100%;
  max-width: 100%;
  text-decoration: none;

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }

  &:focus {
    outline: none;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: ${brand.black};
  }

  @media ${until(Device.TabletSmall)} {
    aspect-ratio: 1/1;
  }
`;
const PartnerLogo = styled.img `
  transform-origin: 50% 0;
  transition: transform 0.25s ${cubicEaseOut};

  ${Partner}[href] & {
    max-height: 54px;

    @media ${until(Device.TabletSmall)} {
      max-height: 90px;
    }
  }

  ${Partner}[href]:hover & {
    transform: scale(1.05);

    @media ${until(Device.TabletSmall)} {
      transform: scale(1.1);
    }
  }
`;
const PartnerCta = styled(FakeButton) `
  @media ${until(Device.Tablet)} {
    margin-top: 15px;
  }

  ${Partner}[href]:hover & {
    div > div {
      transform: translateY(-2px);
    }
  }
`;
export const PartnerListStyles = {
    Container,
    Content,
    ContentArea,
    LogoGrid,
    Partner,
    PartnerCta,
    PartnerLogo,
    Title,
};
